import React from 'react';
import CoachingView from './components/CoachingView/CoachingView';
import ErrorReporter from 'app/components/ErrorReporter';
import { Query, Mutation } from 'react-apollo';
import GET_STUDENTS_AND_PRODUCT_QUERY from './queries/CoachingStudentsAndProduct.gql';
import PURCHASE_PRODUCT_MUTATION from './mutations/PurchaseCoachingProduct.gql';
import { CoachingStudentsAndProduct } from './queries/__generated__/CoachingStudentsAndProduct';
import {
  PurchaseCoachingProductVariables,
  PurchaseCoachingProduct,
} from './mutations/__generated__/PurchaseCoachingProduct';
import ToastActions from 'actions/ToastActions';
import StripeContainer from './components/CoachingView/StripeContainer';
import { ApolloError } from 'apollo-client';
import renderErrorReporter from './CoachingErrorReporter';

export default class CoachingContainer extends React.Component {
  render() {
    return (
      <Mutation<PurchaseCoachingProduct, PurchaseCoachingProductVariables>
        mutation={PURCHASE_PRODUCT_MUTATION}
        onError={(_: ApolloError) =>
          ToastActions.showErrorToast(
            'Please contact coaching@remind.com to complete your purchase.'
          )
        }>
        {(purchaseProduct, purchaseResult) => {
          return (
            <Query<CoachingStudentsAndProduct> query={GET_STUDENTS_AND_PRODUCT_QUERY}>
              {({ loading, error, data }) => {
                if (
                  !loading &&
                  (error || !data || !data.coaching || !data.coaching.purchaseSessionScreen)
                ) {
                  return renderErrorReporter(error || 'Error loading eligible coaching students');
                }

                const students = data && data.coaching && data.coaching.studentFamilyMembers;
                const productVariantUuid =
                  data &&
                  data.coaching &&
                  data.coaching.purchaseSessionScreen &&
                  data.coaching.purchaseSessionScreen.product.productVariantUuid;
                return (
                  <StripeContainer>
                    <CoachingView
                      isLoading={loading}
                      students={students}
                      productVariantUuid={productVariantUuid}
                      purchaseResult={purchaseResult}
                      onSubmit={(
                        productVariantUuid: string,
                        tokenizedCard: string,
                        purchasedForUserUuid: string,
                        email: string,
                        name: string
                      ) => {
                        purchaseProduct({
                          variables: {
                            tokenizedCard,
                            productVariantUuid,
                            email,
                            purchasedForUserUuid,
                            name,
                          },
                        });
                      }}
                    />
                  </StripeContainer>
                );
              }}
            </Query>
          );
        }}
      </Mutation>
    );
  }
}
